import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ClientCard = ({ client, index = 0 }) => {
  return (
    <Link
      to={`/clients/${client.slug}`}
      className="group block overflow-hidden"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#242424]">
        <img
          src={client.cover}
          alt={client.name}
          loading="lazy"
          className="w-full h-full object-cover img-fade transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1 bg-[#0A0A0A]/90 backdrop-blur rounded-full">
          <span className="font-mono-label text-stone-200">{String(index + 1).padStart(2, "0")}</span>
        </div>
        <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-[#0A0A0A] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-1 group-hover:translate-y-0">
          <ArrowUpRight size={16} className="text-stone-100" />
        </div>
      </div>
      <div className="pt-5 flex items-start justify-between gap-6">
        <div>
          <h3 className="font-display text-2xl md:text-3xl font-medium text-stone-100 leading-tight">
            {client.name}
          </h3>
          <p className="font-mono-label text-stone-300 mt-2">{client.industry}</p>
        </div>
        <p className="font-mono-label text-stone-300 whitespace-nowrap pt-2">
          {client.projects.length} {client.projects.length === 1 ? "piece" : "pieces"}
        </p>
      </div>
    </Link>
  );
};

export default ClientCard;
